import instance from "@services/services"
import api from "@services/apiList"
import { emptyError } from "../../../../Types/ServicesType/servicesType"
import { getappointmentPayloadType } from "./type"

const {receptionApi}=api

export const getAppointments=async(body:getappointmentPayloadType)=>{
    try {
        const result=await instance.post(receptionApi.getAppointments,body)
        return result.data.response
    } catch (error) {
        return emptyError
    }
}